export function useTelegramBackButton() {
	const main_store = useMainStore();

	const isTelegramEnv = typeof window !== 'undefined' && window.Telegram?.WebApp?.platform !== 'unknown'
	console.log('isTelegramEnv', isTelegramEnv);

	// Инициализация Telegram BackButton
	if (isTelegramEnv && window.Telegram?.WebApp?.BackButton && !main_store.is_tg_back_button_handler_inited) {
		main_store.set_value('is_tg_back_button_handler_inited', true);
		const BackButton = window.Telegram.WebApp.BackButton;
		BackButton.onClick(async () => {
			if (main_store.tg_back_button_handler) {
				try {
					await main_store.tg_back_button_handler();
				} catch (error) {
					console.error('Error in BackButton handler:', error);
				}
			}
		});
	}

	// Установка обработчика
	const setBackButtonHandler = (handler: () => void | Promise<void>) => {
		console.warn('setBackButtonHandler', handler);
		main_store.set_value('tg_back_button_handler', handler);
	};

	// Очистка обработчика
	const clearBackButtonHandler = () => {
		console.log('clearBackButtonHandler');
		main_store.set_value('tg_back_button_handler', () => {});
	};

	// Получение текущего обработчика
	const getBackButtonHandler = () => {
		console.log('getBackButtonHandler');
		return main_store.tg_back_button_handler;
	};

	// Показать кнопку
	const showBackButton = () => {
		console.log('showBackButton');
		if (isTelegramEnv && window.Telegram?.WebApp?.BackButton) {
			window.Telegram.WebApp.BackButton.show();
		}
		main_store.set_value('is_tg_back_button_visible', true);
	};

	// Скрыть кнопку
	const hideBackButton = () => {
		console.log('hideBackButton');
		if (isTelegramEnv && window.Telegram?.WebApp?.BackButton) {
			window.Telegram.WebApp.BackButton.hide();
		}
		main_store.set_value('is_tg_back_button_visible', false);
	};

	const isBackButtonVisible = main_store.is_tg_back_button_visible;

	return {
		setBackButtonHandler,
		clearBackButtonHandler,
		getBackButtonHandler,
		showBackButton,
		hideBackButton,
		isBackButtonVisible,
	};
}